var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActivity(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.74 3.982a.42.42 0 0 1 .52 0l8.09 6.807a.42.42 0 0 1 .15.32v8.889a.5.5 0 0 1-.51.49H17a.479.479 0 0 1-.47-.49v-5.506a1.002 1.002 0 0 0-1-1H8.5a1 1 0 0 0-1 1v5.506a.501.501 0 0 1-.5.49H4a.48.48 0 0 1-.48-.49v-8.949a.42.42 0 0 1 .15-.32l8.07-6.747Zm.91-1.742a1 1 0 0 0-1.3 0L2.3 9.988a.83.83 0 0 0-.3.63V21.18a.831.831 0 0 0 .83.821H8a1 1 0 0 0 1-1.001v-5.515a.51.51 0 0 1 .5-.491h5.03a.491.491 0 0 1 .5.49V21a1.002 1.002 0 0 0 1 1.001h5.14a.83.83 0 0 0 .83-.82V10.598a.832.832 0 0 0-.3-.631L12.65 2.24Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActivity);
export default __webpack_public_path__ + "static/media/activity.dc9368aea7e26cd25552b7f01b346cd2.svg";
export { ForwardRef as ReactComponent };